module.exports = __webpack_public_path__ + "img/icon3-1.58d832c7.svg";